import API from 'services/api';

export const registerPushNotification = (
  data: { endpoint: string; keys: { p256dh: string; auth: string } } | { deviceToken: string },
) => API.post('/api/notifications/register-push', data);
